import React, { useEffect, useRef, useState } from 'react'
import FormError from '../feedback/FormError'
import toast from 'react-hot-toast'
import OTPInput from "otp-input-react";
import { Link, useNavigate } from 'react-router-dom'
import authServices from '../../services/AuthServices'

function ResetPasswordForm() {
    const [code, setCode] = useState(0)
    const [stage, setStage] = useState(0)
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState()
    const passwordRef = useRef()
    const confirmPassRef = useRef()
    const [passwordType, setPasswordType] = useState("password")
    const navigate = useNavigate()
    const [countdown, setCountdown] = useState(60);
    const [canResend, setCanResend] = useState(false);

    useEffect(() => {
        let timer;
        if (stage === 1 && email && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(prev => {
                    const next = prev - 1;
                    if (next === 0) {
                        setCanResend(true);
                    }
                    return next;
                });
            }, 1000);
        }

        return () => clearTimeout(timer);
    }, [countdown, stage, email]);

    useEffect(() => { }, [error])
    useEffect(() => { }, [code])

    function togglePassword() {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }
    function submitHandler(e) {
        e.preventDefault()
        setLoading(true)
        setError()
        const formData = new FormData()
        formData.append("email", email)
        authServices.sendOtp(formData).then(
            res => {
                setLoading(false)
                toast.success("Sent reset instructions to email")
                setStage(1)
            },
            err => {
                console.error('OTP send error:', err);
                let errorMessage = 'OTP send failed';

                if (err.response?.data) {
                    const data = err.response.data;
                    if (Array.isArray(data.details) && data.details.length > 0) {
                        errorMessage = data.details[0].message || 'OTP send failed';
                    }
                    else if (data.detail) {
                        errorMessage = data.detail;
                    } else if (Array.isArray(data.non_field_errors)) {
                        errorMessage = data.non_field_errors[0];
                    } else if (typeof data === 'string') {
                        errorMessage = data;
                    }
                }

                setError(errorMessage);
                toast.error(errorMessage);
                setLoading(false);
            }
        )
    }
    function submitOTP(e) {

        e.preventDefault()
        setLoading(true)
        const otpToast = toast.loading("Checking OTP...")
        const isValid = checkValid(code)
        if (isValid) {
            toast.success("OTP checked", {
                id: otpToast
            })
            setStage(stage + 1)
            setLoading(false)
        } else {
            setLoading(false)
            toast.error("Please enter the correct OTP length", {
                id: otpToast
            })
            return
        }
    }
    function checkValid(val) {
        if (val === 0) {
            return false
        }
        if (val.length < 6) {
            return false
        } else {
            return true
        }
    }
    function submitPassword(e) {
        e.preventDefault()
        const pass1 = passwordRef.current.value
        const pass2 = confirmPassRef.current.value
        if (pass1 !== pass2) {
            toast.error("Your passwords do not match")
            return
        }
        if (pass1.length < 8) {
            toast.error("Incorrect password length")
            return
        }
        setLoading(true)
        const submitToast = toast.loading("Submitting details...")
        const data = {
            "otp_code": code,
            "password": pass1,
            "password2": pass2
        }
        authServices.resetPassworrd(data).then(
            res => {
                setLoading(false)
                toast.success("Password reset successfully, use it to login", {
                    id: submitToast
                })
                setTimeout(() => {
                    navigate('/auth/login')
                }, 400)
            },
            err => {
                let errorMessage = 'OTP Password set failed';

                if (err.response?.data) {
                    const data = err.response.data;
                    if (Array.isArray(data.details) && data.details.length > 0) {
                        errorMessage = data.details[0].message || 'OTP password set failed';
                    }
                    else if (data.detail) {
                        errorMessage = data.detail;
                    } else if (Array.isArray(data.non_field_errors)) {
                        errorMessage = data.non_field_errors[0];
                    } else if (typeof data === 'string') {
                        errorMessage = data;
                    }
                }

                setError(errorMessage);
                toast.error(errorMessage, {
                    id: submitToast
                });
                setLoading(false);
            }
        )
    }
    const handleResend = async () => {
        console.log('Resending OTP...');
        setLoading(true);
        const formData = new FormData()
        formData.append("email", email)
        try {
            authServices.sendOtp(formData)
            setCountdown(60);
            setCanResend(false);
            toast.success('OTP resent successfully');
        } catch (err) {
            // Handle error (reuse your error parsing logic)
            console.error('Resend failed:', err);
            console.error('OTP send error:', err);
            let errorMessage = 'OTP send failed';

            if (err.response?.data) {
                const data = err.response.data;
                if (Array.isArray(data.details) && data.details.length > 0) {
                    errorMessage = data.details[0].message || 'OTP send failed';
                }
                else if (data.detail) {
                    errorMessage = data.detail;
                } else if (Array.isArray(data.non_field_errors)) {
                    errorMessage = data.non_field_errors[0];
                } else if (typeof data === 'string') {
                    errorMessage = data;
                }
            }

            setError(errorMessage);
            toast.error(errorMessage);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    const maskEmail = (email) => {
        if (!email) return '';
        const [local, domain] = email.split('@');
        const maskedLocal = local ? local[0] + '*'.repeat(local.length - 1) : '';
        return `${maskedLocal}@${domain}`;
    };
    return (
        <div className=''>
            <div className='max-w-md w-full'>
                <div className="bg-white dark:bg-slate-900 p-8 border rounded-lg shadow-2xl">
                    {stage === 0 && (
                        <div className=''>
                            <div className="mb-7">
                                <h2 className="text-3xl font-bold text-primary dark:text-secondary">Reset Password</h2>
                                <p className="text-gray-600 dark:text-gray-400 mt-2">
                                    Enter the email you registered with to get password reset instructions. 
                                    Didn’t receive an email? Please check your <strong>Spam</strong> or <strong>Junk</strong> folder.
                                </p>
                            </div>
                            <form onSubmit={submitHandler} className='space-y-6'>
                                {error && (<FormError error={error} />)}
                                <div className="form-control mb-3">
                                    <label className="label">
                                        <span className="label-text">Email:</span>
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        name="email"
                                        className="input input-bordered w-full" />
                                </div>
                                <div>
                                    <button
                                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? 'Sending...' : 'Send Instructions'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    {stage === 1 && (
                        <div>
                            <form onSubmit={submitOTP} className='space-y-8'>
                                <div className="mb-8">
                                    <h2 className="text-3xl font-bold text-primary dark:text-secondary">User OTP</h2>
                                    <p className="text-gray-600 dark:text-gray-400 mt-2">
                                        Enter the 6 PIN Code that was sent to <span className='text-primary'>{maskEmail(email)}</span> to reset your password
                                    </p>
                                </div>
                                {error && (<FormError error={error} />)}
                                <div className='flex justify-center mb-8'>
                                    <OTPInput
                                        value={code}
                                        inputClassName="border rounded-lg text-black"
                                        inputStyles={{
                                            width: "42px",
                                            height: "42px",
                                        }}
                                        onChange={setCode}
                                        autoFocus={true}
                                        OTPLength={6}
                                        otpType="number"
                                        disabled={false}
                                        secure={false} />
                                </div>
                                <div className='mt-7'>
                                    <button
                                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? 'Checking...' : 'Proceed'}
                                    </button>
                                </div>
                            </form>

                        </div>
                    )}
                    {stage === 2 && (
                        <div>
                            <div className='space-y-8'>
                                <div className="mb-8">
                                    <h2 className="text-3xl font-bold text-primary dark:text-secondary">Enter New Password</h2>
                                </div>
                                <form onSubmit={submitPassword}>
                                    {error && (<FormError error={error} />)}
                                    <div className="form-control mb-3">
                                        <label className="label">
                                            <span className="label-text">Password:</span>
                                        </label>
                                        <input
                                            type={passwordType}
                                            required
                                            ref={passwordRef}
                                            name="password1"
                                            className="input input-bordered w-full " />
                                    </div>
                                    <div className="form-control mb-3">
                                        <label className="label">
                                            <span className="label-text">Confirm Password:</span>
                                        </label>
                                        <input
                                            type={passwordType}
                                            required
                                            ref={confirmPassRef}
                                            name="password2"
                                            className="input input-bordered w-full" />
                                    </div>
                                    <div className='mb-5 flex gap-3 items-center'>
                                        <label className="label">
                                            <span className="label-text">Show Password</span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            onClick={togglePassword} />
                                    </div>
                                    <div>
                                        <button
                                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading ? 'Setting...' : 'Set Password'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                    <div className="mt-6 text-center">
                        {stage === 0 && (
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Don’t have an account?{' '}
                                <Link
                                    className="font-medium text-secondary hover:text-orange-400 ml-1"
                                    to="/auth/register"
                                >
                                    Sign up
                                </Link>
                            </p>
                        )}
                        {stage === 1 && email && (
                            <div>
                                {canResend ? (
                                    <button
                                        onClick={handleResend}
                                        disabled={loading}
                                        className="btn btn-ghost"
                                    >
                                        Resend OTP
                                    </button>
                                ) : (
                                    `Resend OTP in ${countdown}s`
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPasswordForm